// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { WlCurrency } from '../../../../tools/environments'; // Included with Angular CLI.
import { version } from '../../../../package.json';
const sentryConfig = {
    dsn: 'APP_SENTRY_DSN',
    debug: false,
    release: version,
    environment: process.env.CLIENT_NAME + '-dev',
};
export const environment = {
    production: false,
    sentryClientTag: process.env.CLIENT_NAME + '-dev',
    apiUrl: process.env.API_URL || window.location.origin + '/api',
    deployUrl: '/',
    role: [],
    projectVersion: version,
    sentryConfig,
    wlId: '',
    wlAuthLogo: './assets/images/logo.svg',
    wlMainLargeLogo: './assets/images/logos/main-logo.svg',
    wlMainSmallLogo: './assets/images/logos/small-logo.svg',
    wlFavicon: './assets/images/favicon.ico',
    wlPreloader: './assets/images/loading/loading-logo.png',
    wlCompanyName: 'Aff Dist',
    wlHomePageLink: 'https://affdist.com',
    wlTNCLink: 'https://affdist.com/terms-and-conditions',
    wlSupportEmail: 'info@affdist.com',
    wlRegistrationSupportTelegram: 'KateHelpHO',
    wlCurrency: WlCurrency.USD,
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';
